import { IAuthedAdmin } from 'types';

// 메뉴 URL → 필요한 permission code. 맵에 없는 URL 은 숨김 (새 메뉴는 꼭 추가).
const MENU_ACCESS: Record<string, string> = {
  '/users': 'user:list',
  '/user-groups': 'user_group:list',
  '/event': 'event:list',
  '/event/additional-info': 'additional_template:list',
  '/feedback': 'feedback_template:list',
  '/partner': 'partner:list',
  '/platform/home': 'home:get',
  '/collection': 'collection:list',
  '/content': 'content:list',
  '/stickers': 'sticker:list',
  '/platform/quick-menu': 'quick_menu:list',
  '/push': 'push:list',
  '/organizations': 'org:list',
  '/accounts': 'admin:list',
  '/permission': 'role:list',
  '/org-members': 'org_member:list',
};

export function canSeeMenu(
  to: string,
  user: IAuthedAdmin | undefined,
): boolean {
  if (!user) return false;
  const permission = MENU_ACCESS[to];
  if (!permission) return false;
  return user.permissions.includes(permission);
}
